import { render, staticRenderFns } from "./IncomeStatistics.vue?vue&type=template&id=5be9c596&scoped=true&"
import script from "./IncomeStatistics.vue?vue&type=script&lang=js&"
export * from "./IncomeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./IncomeStatistics.vue?vue&type=style&index=0&id=5be9c596&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be9c596",
  null
  
)

export default component.exports